import api from '@/apis/di/statisticAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('statistic', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_statistic',
    field: {
      key: 'statistic_id',
      code: 'statistic_code',
      name: 'statistic_name',
      quickFollow: 'inactive', // NTLoc-2022/05/06 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
